export enum AuthEvent {
    SIGNED_IN = 'signedIn',
    SIGNED_OUT = 'signedOut',
    TOKEN_REFRESH = 'tokenRefresh',
    TOKEN_REFRESH_FAILURE = 'tokenRefresh_failure',
}
